document.documentElement.style.setProperty('--theme-primary', '#46cdcd');
document.documentElement.style.setProperty(
  '--button-primary-active-background',
  'rgb(0,170,170)',
);
document.documentElement.style.setProperty(
  '--button-primary-active-border',
  'rgb(0,170,170)',
);
